import React, {useState} from 'react';
import { Box, useMediaQuery, useTheme} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { YtdReportColumns, YtdReportNonCandidateColumns } from '../../../types/referenceData/reportTableColumns';
import YtdReport from '../../../types/reports/ytdReport';

interface Props {
   tableRows?:YtdReport[];
   isCandidate: boolean;
}

const YearToDateReportsTable = (props: Props): JSX.Element => {

    const [tableColumns, setColumns] = useState(props.isCandidate?YtdReportColumns:YtdReportNonCandidateColumns);
    const theme = useTheme(); 
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));
    const totalCount = props.tableRows?.length ?? 0;

    return (
        <Box 
        sx={{ 
        //display: 'flex', 
        //flexDirection: 'column',
        width: '95%',
        '.MuiDataGrid-columnHeaderTitle': { 
            fontWeight: 'bold !important',
        },
        }}>
        <DataGrid 
            rows={props.tableRows}
            getRowHeight={isSM? ()=> 'auto': () => 42}
            //rowHeight={isSM? 'auto': 40}
            columns={tableColumns}
            getRowId={(row) => row.cpfId}
            disableColumnMenu
            disableRowSelectionOnClick
            hideFooterSelectedRowCount
            columnVisibilityModel={{
              cpfId: isSM?false:true,
              filerName: isSM?false:true,
              filerNameWithId: isSM?true:false,
            }}
            hideFooterPagination={totalCount < 100? true: false}
            sx={{ 
              '.MuiDataGrid-cell': {
                whiteSpace: 'normal', 
                wordBreak: 'break-word',
                //paddingTop: '3px!important',
                //paddingBottom: '3px!important',
              },
            }}
        />
      </Box>
    );
}

export default YearToDateReportsTable;